import React from 'react'
import { Button, Flex, Input, Typography } from 'antd'
import { Droppable } from 'react-beautiful-dnd'
import { RollbackOutlined } from '@ant-design/icons'
import { useThemeColors } from '../../../../../../../../hooks/useThemeColors'

const { Text } = Typography

const InputWithRubricValue = ({
    value,
    onChange,
    originalValue,
    onRollbackToOriginal,
    hasRubricValue,
    inputComponent: InputComponent = Input,
    ...props
}) => (
    <div>
        <Input.Group>
            <Flex align='center' gap={8}>
                <InputComponent value={value} onChange={onChange} {...props} />
                {hasRubricValue && (
                    <Button
                        type='text'
                        icon={<RollbackOutlined />}
                        onClick={onRollbackToOriginal}
                        title='Rollback to Original Value'
                    />
                )}
            </Flex>
        </Input.Group>
        {originalValue && (
            <Text type='secondary' style={{ fontSize: '12px', display: 'block', marginTop: '4px' }}>
                Original: {originalValue}
            </Text>
        )}
    </div>
)

export const DroppableInput = ({
    value,
    onChange,
    droppableId,
    placeholder,
    originalValue,
    onRollbackToOriginal,
    hasRubricValue,
    inputComponent,
    ...props
}) => {
    const colors = useThemeColors()
    return (
        <Droppable droppableId={droppableId}>
            {(provided, snapshot) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                    <InputWithRubricValue
                        value={value}
                        onChange={onChange}
                        placeholder={placeholder}
                        originalValue={originalValue}
                        onRollbackToOriginal={onRollbackToOriginal}
                        hasRubricValue={hasRubricValue}
                        inputComponent={inputComponent}
                        style={{
                            border: snapshot.isDraggingOver ? `1px dashed ${colors.primary}` : undefined,
                            backgroundColor: snapshot.isDraggingOver ? colors.hoverBg : undefined,
                        }}
                        {...props}
                    />
                </div>
            )}
        </Droppable>
    )
}
